export default __webpack_public_path__ + "static/media/chatAudio.34115496.mp3";